import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import api from "@/lib/api";

const inputClass = "w-full rounded-lg border border-[#282C37] bg-[#0A0B0E] px-4 py-3 text-amber-50 focus:border-[#D4AF37] focus:outline-none";

export default function PasswordRecovery({ mode }) {
  const [token] = useState(() => new URLSearchParams(window.location.search).get("token") || "");
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (mode === "confirm" && token) window.history.replaceState(null, "", "/saas/redefinir-senha");
  }, [mode, token]);

  const submit = async (event) => {
    event.preventDefault();
    if (mode === "confirm" && password !== confirmation) {
      toast.error("A confirmação da nova senha não confere.");
      return;
    }
    setBusy(true);
    try {
      if (mode === "request") {
        await api.post("/saas/password-reset/request", { identifier });
      } else {
        await api.post("/saas/password-reset/confirm", { token, new_password: password });
      }
      setDone(true);
      if (mode === "confirm") toast.success("Senha redefinida. Entre com a nova senha.");
    } catch (error) {
      const detail = error?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Não foi possível concluir a solicitação.");
    } finally {
      setBusy(false);
    }
  };

  return <main className="min-h-screen flex items-center justify-center bg-[#0A0B0E] px-4 py-10">
    <div className="card-surface w-full max-w-md p-7 sm:p-9" style={{ background: "#12141A" }}>
      <ShieldCheck className="mb-5 h-8 w-8 text-[#D4AF37]" />
      <h1 className="font-display text-2xl gold-text">{mode === "request" ? "Recuperar acesso" : "Redefinir senha"}</h1>
      {done ? <p className="mt-5 text-sm leading-6 text-stone-300">{mode === "request" ? "Se houver uma conta elegível e o envio estiver disponível, você receberá as instruções em breve." : "Sua senha foi redefinida. Todas as sessões anteriores foram encerradas."}</p> : mode === "confirm" && !token ? <p className="mt-5 text-sm text-stone-300">Link de redefinição inválido.</p> : <form onSubmit={submit} className="mt-6 space-y-4">
        {mode === "request" ? <><p className="text-sm leading-6 text-stone-400">Informe seu usuário/login ou e-mail de recuperação.</p><label className="block text-sm text-stone-300">Usuário/Login ou e-mail<input required autoComplete="username" value={identifier} onChange={(event) => setIdentifier(event.target.value)} className={`mt-1.5 ${inputClass}`} /></label></> : <><label className="block text-sm text-stone-300">Nova senha<input required type="password" minLength="12" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} className={`mt-1.5 ${inputClass}`} /></label><label className="block text-sm text-stone-300">Confirmar nova senha<input required type="password" minLength="12" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} className={`mt-1.5 ${inputClass}`} /></label><p className="text-xs text-stone-500">Use pelo menos 12 caracteres e uma senha diferente da anterior.</p></>}
        <button disabled={busy} className="w-full rounded-lg bg-[#D4AF37] px-4 py-3 font-semibold text-[#0A0B0E] disabled:opacity-60">{busy ? "Aguarde…" : mode === "request" ? "Solicitar link" : "Redefinir senha"}</button>
      </form>}
      <Link to="/saas/login" className="mt-6 inline-block text-sm text-[#D4AF37] hover:text-[#E5C158]">Voltar ao login</Link>
    </div>
  </main>;
}
